module.exports = __webpack_public_path__ + "static/media/best-team.1a1e3c87.png";